import { hideAlert, toggleAuthPopup } from "@components/alert/action";
import { getActiveLanguage, getLanguages, getTranslate } from "react-localize-redux";
import { connect } from "react-redux";
import { BettoAlert } from "./BettoAlert";

const mapStateToProps = (state) => ({
	alert: state.alert,
	translate: getTranslate(state.localize),
	languages: getLanguages(state.localize),
	currentLanguage: getActiveLanguage(state.localize).code,
});

const mapDispatchToProps = {
	hideAlert,
	toggleAuthPopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(BettoAlert);
